import { Injectable } from "@angular/core";
import { ApiService } from "app/core/http/api.service";
import { buildHttpOptions } from "app/core/http/BuildHttpOptions";
import { Observable } from "rxjs";

export class SalesAdminDashboardSummaryResponse {
    reservedVehicles: SalesDashboardSummaryVehicleDto[];
    contractsInProgress: SalesDashboardSummaryContractDto[];
    soldCarsThisWeek: SalesDashboardSummarySoldCarDto[];
    pendingDeliveries: number;
    totalSales: number;
    totalContracts: SalesAdminDashboardContractsDto[];
    topSellers: SalesAdminTopSellersDto[];
}
export interface SalesDashboardSummaryVehicleDto {
    expiringSoon: boolean;
}

export interface SalesDashboardSummaryContractDto {
    awaitingDocs: boolean;
}

export interface SalesDashboardSummarySoldCarDto {
    delivered: boolean;
}

export interface SalesAdminTopSellersDto {
    sellerId: string;
    sellerName: string;
    amountSold: number;
    contractsClosed: number;
    percentageOfTotalRevenue: number;
}

export interface SalesAdminDashboardContractsDto {
    internNumber: number;
    date: string;
    status: LegacyContractStatusEnum;
    purchasePrice: number,
    totalSalePrice: number,
    totalAdditionalCost: number,
    totalAdditionalExpense: number,
    totalPaid: number,
    profitOnVehicle: number,
    TotalTradeIn: number
}

export enum LegacyContractStatusEnum {
    Unknown = 0,
    Canceled = 1,
    InProcess = 2,
    Completed = 3,
    Accounted = 4
}

@Injectable({ providedIn: 'root' })
export class SalesAdminDashboardService {

    dashboardUrl = '/dashboard/sales-admin/';
    constructor(private api: ApiService) { }

    getSalesAdminDashboardData(soldCarsTimePeriod: string, year: number, salesPeriod: string): Observable<SalesAdminDashboardSummaryResponse> {

        const options = buildHttpOptions({
            extraParams: { soldCarsTimePeriod: soldCarsTimePeriod, year: year, salesPeriod: salesPeriod }
        });

        return this.api.get<SalesAdminDashboardSummaryResponse>(this.dashboardUrl + 'summary', options);
    }

}
